import './App.css';
import AppRouter from './routes/AppRouter';
import Layout from './components/layout/Layout';
import React, { useEffect, useState } from 'react';
import { WebSocketProvider } from './contexts/WebSocketContext';
import ToastProvider from './contexts/ToastContext';
import { View, StyleSheet, DimensionValue } from 'react-native';
import { FullScreenSpinner } from './components/molecules/Spinner';
import { useAuth } from 'react-oidc-context';

const styles = StyleSheet.create({
  appViewStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh' as DimensionValue,
    width: '100vw' as DimensionValue
  }
});

function App(): React.ReactElement {
  const authContext = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkFirstLogin = async () => {
      try {
        setIsLoading(true);
        if (!authContext?.isAuthenticated) {
          await authContext?.signinRedirect();
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    if (authContext?.isLoading === false) {
      checkFirstLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext?.isAuthenticated]);

  if (isLoading) {
    return (
      <View style={styles.appViewStyle}>
        <FullScreenSpinner />
      </View>
    );
  }

  return (
    <WebSocketProvider walletId={'verification'}>
      <ToastProvider>
        <Layout title="Verification Application">
          <AppRouter />
        </Layout>
      </ToastProvider>
    </WebSocketProvider>
  );
}

export default App;
